// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"b68b1791","205":"b68b1791","683":"b68b1791"}[chunkId] + ".chunk.css";
};